export function Loader({ label = 'Loading…' }) {
  return (
    <div className="loader" role="status">
      <span className="spinner" aria-hidden="true" />
      {label}
    </div>
  );
}

/** Errors say what happened and what to do. They never apologise. */
export function ErrorAlert({ message, onRetry }) {
  if (!message) return null;
  return (
    <div className="alert error" role="alert">
      {message}
      {onRetry && (
        <>
          {' '}
          <button className="action-btn" onClick={onRetry} style={{ marginLeft: 6 }}>
            Try again
          </button>
        </>
      )}
    </div>
  );
}

export function InfoAlert({ children }) {
  return <div className="alert info">{children}</div>;
}

/** An empty screen is an invitation to act, so pass a message that says what to do. */
export function EmptyRow({ colSpan, children = 'No entries yet' }) {
  return (
    <tr className="placeholder-row">
      <td colSpan={colSpan}>{children}</td>
    </tr>
  );
}

export function StatusBadge({ status }) {
  if (status === 'disabled') return <span className="badge disabled">Disabled</span>;
  if (status === 'pending') return <span className="badge pending">Pending</span>;
  return null;
}
